import React from 'react';
import { Box, Typography, RadioGroup, FormControlLabel, Radio } from '@mui/material';

// Subcomponent for radio group questions
const RadioGroupQuestion = ({ question, questionNumber, answerOptions, onAnswerChange, answer }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="body1" sx={{ mb: 1 }}>
      {questionNumber}. {question.text}
    </Typography>
    {(question.items || [null]).map((item, itemIndex) => (
      <Box key={item?.id || 0} sx={{ mb: question.items ? 2 : 0 }}>
        {item && (
          <Typography variant="body2" sx={{ mb: 1 }}>
            {item.label}
          </Typography>
        )}
        <RadioGroup
          value={question.items ? answer?.[itemIndex] ?? '' : answer ?? ''}
          onChange={
            onAnswerChange === null ? null :
            e => onAnswerChange(e.target.value, question.items ? itemIndex : undefined)
          }
        >
          {answerOptions.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value.toString()}
              control={
                <Radio
                  disableRipple={onAnswerChange === null}
                  disableFocusRipple={onAnswerChange === null}
                  disableTouchRipple={onAnswerChange === null}
                  sx={{alignSelf: 'flex-start'}}
                />
              }
              label={option.label}
              sx={{mb: 1.5}}
            />
          ))}
        </RadioGroup>
      </Box>
    ))}
  </Box>
);

export default RadioGroupQuestion;